export const URL = '/api/user/all'
